module.exports = __webpack_public_path__ + "static/img/role2.4cac6c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/index1/role2.png
// module id = PQ3b
// module chunks = 7